// Product Page Scripts

function productFunctions(jQuery) {

  var currencyCharacter = $(".currency_code").val().charAt(0);
  $(".discount_bubble span.selected_currency").html(currencyCharacter);

  $(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 800) {
      $('.rmz-chat-bubble').addClass('change_chat_pos');
      $(".smile-launcher-frame").hide();
      $("#reamazejs-container").hide();
    } else {
      $('.rmz-chat-bubble').removeClass('change_chat_pos');
      $(".smile-launcher-frame").show();
      $("#reamazejs-container").show();
    }
    var docHeight = $(document).height();
    var hidePos = docHeight - 500;
     if($(window).scrollTop() + $(window).height() > hidePos || y < 800) {
         $('.atc_sticky').fadeOut();
     } else if ($(window).scrollTop() + $(window).height() < hidePos && y > 800) {
       $('.atc_sticky').fadeIn();
     }
  });

    // Example 1
    $("#header_bar.sticky_gallery").stickOnScroll({
        topOffset: 0,
        setParentOnStick:   true,
        setWidthOnStick:    false
    });
  
    $("#product_upper_left.sticky_gallery")
      .stickOnScroll({
          topOffset:          $("#header_bar").outerHeight(),
          bottomOffset:       0,
          footerElement:      $("#product_lower"),
          setParentOnStick:   true,
          setWidthOnStick:    true
    });

    $(window).resize(function() {
      var testing = $(".testing").width();
      var topBarHeight = $(".top_bar").outerHeight();
      $("#product_upper_left.sticky_gallery").css({"width" : testing, "position" : "static"});
    });

    $(".shopify-section.featured_products").appendTo(".faq_section_append");
    $(".section.comparesec").parent(".shopify-section").appendTo(".compare_section_append");

}

// Blog

function blogFunctions(jQuery) {

    $( "span#topic_dropdown_button" ).click(function() {
      $(".blog_sort_buttons").toggle();
      $(this).toggleClass("button_arrow_down");
    });

    $(document).click(function(e) {
        if (!$(e.target).is('.blog_sort_buttons, .blog_sort_buttons *, #topic_dropdown_button, #topic_dropdown_button *') && $(window).width() < 650 ) {
          $(".blog_sort_buttons").hide();
        }
    });

    if (window.location.href.indexOf("makeup") > -1) {
       $('span#topic_dropdown_button').text('makeup');
       $("#topic_button_makeup").css("background", "#eee");
    } else if (window.location.href.indexOf("skincare") > -1) {
       $('span#topic_dropdown_button').text('skincare');
       $("#topic_button_skincare").css("background", "#eee");
    } else {
       $('span#topic_dropdown_button').text('all topics');
       $("#topic_button_all").css("background", "#eee");
    }

    if ($(window).width() > 650) {
        $("#topic_button_all").show();
        $("#topic_button_makeup").show();
        $("#topic_button_skincare").show();
    }


    $(window).resize(function() {
      if (window.location.href.indexOf("makeup") > -1 && $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('makeup');
         $("#topic_button_makeup");
      } else if (window.location.href.indexOf("skincare") > -1 && $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('skincare');
         $("#topic_button_skincare");
      } else if ( $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('all topics');
         $("#topic_button_all");
      }

      if ($(window).width() > 649) {
          $(".blog_sort_buttons").show();
          $("#topic_button_all").css("display", "inline-block");
          $("#topic_button_makeup").css("display", "inline-block");
          $("#topic_button_skincare").css("display", "inline-block");
          $("span#topic_dropdown_button").removeClass("button_arrow_down");
      } else if ($(window).width() < 650) {
          $(".blog_sort_buttons").hide();
          $("#topic_button_all").css("display", "block");
          $("#topic_button_makeup").css("display", "block");
          $("#topic_button_skincare").css("display", "block");
      }

    });

}

///// SECTIONS /////

// My Cart 

function myCartFunctions(jQuery) {
  
  $(document).ready(function() {
    var windowWidth = $(window).width();
    if ($(window).width() < 360) {
       $(".my-cart").css("width", windowWidth);
    }
  });
  $(window).resize(function() {
    var windowWidth = $(window).width();
    if ($(window).width() < 360) {
       $(".my-cart").css("width", windowWidth);
    }
  });
  $( "#header_cart" ).click(function() {
    $("#smile-ui-lite-container").hide();
    $("#reamazejs-container").hide();
    var startTime = new Date().getTime(); // Get the current time
    
    var interval = setInterval(function() {
      var currentTime = new Date().getTime(); // Get the current time again
      
      var elapsedTime = currentTime - startTime; // Calculate the elapsed time
      
      if (elapsedTime >= 1600) { // Stop the interval after 3 seconds
        clearInterval(interval);
      }
      
        var cartBottomHeight = $(".cart_bottom").outerHeight();
        $(".my-cart__items").css("height", "calc(100% - " + cartBottomHeight + "px");
      
    }, 200); // Run the function every 0.2 seconds (200 milliseconds)
  });
  $(".cart_close").click(function() {
    $("#smile-ui-lite-container").show();
    $("#reamazejs-container").show();
  });
  $("#cover_page").click(function() {
    $("#smile-ui-lite-container").show();
    $("#reamazejs-container").show();
    $(this).hide();
  });
}